import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const PillContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin: ${SPACING.S16} 0 0 0;
  min-height: ${SPACING.S32};

  div.filter-pill {
    align-items: center;
    background: ${COLORS3.WHITE_100};
    border-radius: 100px;
    border: 1px solid ${COLORS3.BLACK_100};
    display: flex;
    flex-flow: row-reverse;
    height: ${SPACING.S32};
    margin-bottom: 0;
    outline: 0;
    padding: ${SPACING.XS} ${SPACING.SM};

    &:hover,
    &:active,
    &:focus {
      border: 1px solid ${COLORS3.BLACK_100};
    }

    & > div.pill-label {
      color: ${COLORS3.BLACK_100};
      font-family: ${FONT.FAMILY.SANS_SERIF};
      font-size: ${FONT.SIZE.SMALLER};
      font-weight: ${FONT.WEIGHT.MEDIUM};
      line-height: ${SPACING.MD};
      margin: 0 0 0 ${SPACING.XS};
    }
  }

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    overflow-x: auto;
    padding: 0 ${SPACING.MD} ${SPACING.MD} 0;
  }
`;

export const StylesLinkSmDevices = css`
  margin: 0 ${SPACING.XS} 0 0;
`;

export const StylesLinkLgDevices = css`
  margin: 0 0 0 ${SPACING.XS};
`;
